module.exports = __webpack_public_path__ + "img/Microscopium.3e7abb36.png";